<template>
    <el-select
            v-bind="$attrs"
            :value="value"
            @input="onInput"
    >
        <el-option
                v-for="{value, label, inDoNotContact} in options"
                :key="value"
                :label="label"
                :value="value"
                :disabled="inDoNotContact"
        >
            <el-tooltip
                    v-if="inDoNotContact"
                    effect="light"
                    content="Do Not Contact feature restriction"
                    placement="top-start"
            >
                <span class="text-danger cursor-default"><i class="fas fa-user-slash"></i></span>
            </el-tooltip>
            {{ label }}
        </el-option>
    </el-select>
</template>

<script>

  export default {
    props: {
      outgoingNumbers: Array,
      formatter: Function,
      value: Number,
      selectedContact: Object,
    },

    computed: {
      /**
       * @return {array|null}
       */
      doNotContact() {
        return _.get(this.selectedContact, 'do_not_contact', []);
      },

      /**
       * @return {object|null}
       */
      current() {
        return _.find(this.outgoingNumbers, {id: this.value}) || null;
      },

      /**
       * @return {Array}
       */
      options() {
        return _.map(this.outgoingNumbers, item => {
          return {
            value: item.id,
            label: this.formatter(item),
            inDoNotContact: this.inDoNotContact(item),
          };
        })
      },
    },

    watch: {
      selectedContact(val) {
        if (this.inDoNotContact(this.current)) {
          this.emitInput(null);
        }
      },
    },

    methods: {
      /**
       * @param {*} value
       */
      onInput(value) {
        this.emitInput(value);
      },

      /**
       * @param {*} value
       */
      emitInput(value) {
        this.$emit('input', value || null);
      },

      /**
       * @param {object} outgoingNumber
       * @return {boolean}
       */
      inDoNotContact(outgoingNumber) {
        return Boolean(_.find(this.doNotContact, {brand_id: _.get(outgoingNumber, 'brand_id', null)}));
      }
    },
  }
</script>
